




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

interface Budget {
    campaign: {
        label: string;
    };
}

@Component({ components: { SimpleText } })
export default class BudgetCampaignLabel extends Vue {
    @Prop( { default: null }) public budget !: Budget;

    public static getNeededFields(): string[] {
        return [
            "budget.label",
            "budget.uuid",
            "budget.campaign.uuid",
            "budget.campaign.label"
        ];
    }
}
